import {canManageExpiration} from '@netx/core-asset-expiration/enablers';
import {type ISavedCart} from '../schema';
import {savedCartIsEmpty} from './savedCartIsEmpty';

export const canManageSavedCartExpiration = (savedCart?: ISavedCart) => {
	if (savedCartIsEmpty(savedCart)) return false;
	return canManageExpiration();
};
